module.exports = __webpack_public_path__ + "img/CHEVROLET.82c620ff.svg";